import { store } from '@atredux/store'
import { getSelectedLocale } from '@src/redux/selectors/localeSelector'
import { getToolUrl } from '@src/services/ToolMenuConfigService'

const NOTIFICATION_TOOL_NAME: string = 'Store Tasks V2'
const NOTIFICATION_TOOL_ID: string = 'status_page_v2'

export class NotificationModalUtils {
    private static notificationBaseUrl: string
    private static notificationParams: string

    public static getUrl () {
        if (!this.notificationBaseUrl) {
            const url = getToolUrl(NOTIFICATION_TOOL_NAME, NOTIFICATION_TOOL_ID)
            this.notificationBaseUrl = url?.split('?')[0]
            this.notificationParams = url?.split('?')[1]
        } else {
            const localeParam = store?.getState().locale ? getSelectedLocale(store.getState()) : 'en-US'
            const queryParams = new URLSearchParams(this.notificationParams)
            queryParams.set('locale', localeParam)
            this.notificationParams = queryParams.toString()
        }

        if (!this.notificationBaseUrl) {
            return ''
        }
        return this.notificationBaseUrl + '?' + this.notificationParams
    }
}
